import { cleanMask } from './cleanMask';

interface GetPhoneErrorMessageParams {
  maskedPhone: string;
  telCode: string | undefined;
  minDigits: number;
  maxDigits: number;
  required: boolean;
  isEdited: boolean;
}

interface PhoneErrorResult {
  /** Текст для отображения в UI (учитывает isEdited и isEmpty) */
  errorMessage: string;
  /** Реальная валидность поля (не зависит от isEdited/isEmpty, используется при сабмите) */
  isValid: boolean;
}

/**
 * Вычисляет ошибку телефона.
 *
 * Разделение:
 * - `isValid`      — основано на raw ошибке; используется при сабмите формы
 * - `errorMessage` — фильтруется по isEdited/isEmpty; показывается во время ввода
 *
 * Исправленная логика (баг был здесь):
 * Раньше: `!isEmpty && isEdited && error` — при required=true и пустом поле
 *         isEmpty=true подавляло ошибку, и она не показывалась вообще.
 * Теперь: `isEdited && error && (required || !isEmpty)` — при required=true
 *         ошибка показывается независимо от isEmpty.
 */
export const getPhoneErrorMessage = ({
  maskedPhone,
  telCode,
  minDigits,
  maxDigits,
  required,
  isEdited,
}: GetPhoneErrorMessageParams): PhoneErrorResult => {
  const clearPhone = cleanMask(maskedPhone);
  const phoneLength = clearPhone.length;
  const isEmpty = clearPhone === '' || clearPhone === telCode;

  let rawError: string | null = null;

  if (phoneLength > maxDigits) {
    rawError = 'Телефон превышает допустимую длину';
  } else if (required) {
    if (phoneLength === 0) rawError = 'Введите номер телефона';
    else if (phoneLength < minDigits) rawError = 'Телефон введен не полностью';
  } else {
    if (phoneLength > 0 && phoneLength < minDigits)
      rawError = 'Телефон введен не полностью';
  }

  const errorMessage =
    isEdited && rawError && (required || !isEmpty) ? rawError : '';

  return { errorMessage, isValid: !rawError };
};
